import { FaAward, FiUsers, VscFolderLibrary } from 'react-icons/all';

interface IAboutMeWidgetData {
  icon: any;
  label: string;
  description: string;
}

export const aboutMeWidgetData: IAboutMeWidgetData[] = [
  {
    icon: <FaAward />,
    label: 'Experience',
    description: '>1 Year Working',
  },
  {
    icon: <FiUsers />,
    label: 'Clients',
    description: '5 Worldwide',
  },
  {
    icon: <VscFolderLibrary />,
    label: 'Project',
    description: '10+ Completed',
  },
];
